import WizardModalStep from "../wizard-modal/wizard-modal-step/wizard-modal-step.component";
import { ReactComponent as CloseIcon } from "../../icons/close.svg";
import {
  CMBoxcontainer,
  CMButton,
  CMCloseButton,
  CMDescription,
  CMDisBox,
  CMDisclaimer,
  CMTitleStyle,
  CMwizardFundsBid
} from "./login-required.styles";
import { Form,Formik } from "formik";
import { useMediaQuery } from "@mui/material";
import WizardModal2 from "../wizard-modal/wizard-modal.component2";
import { Link, useNavigate } from "react-router-dom";
import Button from "../button/button.component";
import { useState } from "react";
import { useEffect } from "react";

const initialValues = {
  bidPerUnit: 0,
  totalUnit: 0,
  dollar: '$'
}

const LoginRequired = ({ open, handleClose, redirectUrl }) => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const navigate = useNavigate();

  const handleClosed = () => {
    handleClose(); // Set a value that indicates the wizard is closed
  };

  const transhandleClosed = () => {
    handleClose();
  };

  return (
    <>
      <WizardModal2 open={open} onClose={handleClose}>
        <CMCloseButton onClick={handleClosed}>
          <CloseIcon width={16} height={16} />
        </CMCloseButton>
        <WizardModalStep
          title="Login Required"
          style={CMwizardFundsBid}
          titleStyle={CMTitleStyle}
        >
          <div>
          <CMBoxcontainer className="dotted-border">
            <CMDisBox>
              <CMDisclaimer>
                <h3>
                  This content is only available for registered users.<br/>
                  Please sign in.
                </h3>
              </CMDisclaimer>
            </CMDisBox>
            <CMButton>
              <Button as={Link} to={`/auth?returnUrl=${encodeURIComponent(redirectUrl)}`}>Login</Button>
            </CMButton>
          
          </CMBoxcontainer>
          </div>
        </WizardModalStep>
      </WizardModal2>
    </>
  );
};
export default LoginRequired;
